import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./store/store";
//import {HandleErrors, CathTokenRenewal} from './handlers/RequestHandler';
import { Provider } from "react-redux";
// import * as Sentry from "@sentry/react";
// import { version } from "../package.json";

//import { BrowserTracing } from "@sentry/tracing";
/*

*/

var retries = 0; // Esta variable previene que se muestre varias veces el modal, en caso de dispararse varios errores consecutivos

// Sentry.init({
//     dsn:
//         window.location.hostname !== "localhost"
//             ? "https://910bc0b67107404e80ac9875eca94bd6@sentry.simgulary.io/19"
//             : null,
//     release: "dondemand-admin@" + version,
//     tracesSampleRate: 1.0,
//     beforeSend(event, hint) {
//         // let dialogTimeout;

//         // Check if it is an exception, and if so, show the report dialog
//         if (event.exception) {
//             if (retries === 0) {
//                 // && !dialogTimeout){
//                 retries = 1;
//                 //clearTimeout(this.dialogTimeout);
//                 /* dialogTimeout =  setTimeout...* /
// 				setTimeout(() => {
// 					Sentry.showReportDialog({
// 						eventId: event.event_id,
// 						lang: "es"
// 					});
// 					retries = 0;
// 				}, 250);
// 				/*if (dialogTimeout !== undefined) {
// 					clearTimeout(dialogTimeout);
// 				}*/
//             }
//         }
//         return event;
//     },
// });

// agregar dialogo para capturar error del usuario
// https://sentry.simgulary.io/settings/simgulary/projects/dondemand-dashboard/install/javascript-react/

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js